import { Descriptions, Modal } from 'antd';
import * as React from 'react';
import { IOrderInfo, ILogistics } from 'src/entity/OrderEntity';
import { EPayStatus } from 'src/constants/Order';
import TextArea from 'antd/lib/input/TextArea';
import car from '../../../../assets/imgs/car.svg';
import { ILogistic, ITraces } from 'src/entity/logistics';
import { MallService } from 'src/services/MallService';
import { UtilDateTime } from 'src/utils/datetime';

import { SUPPORT_EXPRESSES } from 'src/services/MallService';
import I18N from 'src/services/I18NService';

export interface ILogisticsEdit extends ILogistics {
  /** 物流种类 0-订单物流，1-发票物流 */
  logisticsType: 0 | 1;
}

interface ILogisticsInfoProps {
  /** 订单明细 */
  orderInfo: IOrderInfo;
  /** 是否是代理商 */
  isAgent: boolean;
  /** 发票物流 */
  invoiceLogistics: ILogistics | null;
  /** 订单物流 */
  orderLogistics: ILogistics;
  /** 药品物流的结构化地址 */
  structureAddress: string;
  /** 修改物流信息回调 */
  changeLogistics(value: ILogisticsEdit): void;
  handleLogisticInfo(value: ILogistic): void;
}

interface ILogisticsInfoState extends ILogisticsEdit {
  /** 修改物流信息对话框 */
  logisticsVisible: boolean;
  logisticInfo: ILogistic;
  latestLogisticInfo: ITraces;
  showExpress: boolean;
}

class LogisticsInfo extends React.Component<ILogisticsInfoProps, ILogisticsInfoState> {
  constructor(props: ILogisticsInfoProps) {
    super(props);

    this.state = {
      logisticsVisible: false,
      logisticsType: 0,
      logisticsCompany: '',
      expressNumber: '',
      logisticInfo: {} as ILogistic,
      latestLogisticInfo: {} as ITraces,
      showExpress: false
    };
  }

  async componentWillReceiveProps() {
    const express = this.props.orderInfo.express;
    // 只有已完成， 已签收，已发货的订单才查询物流轨迹
    const canSearchExpress = this.props.orderInfo.pay_status === EPayStatus.已发货 ||
      this.props.orderInfo.pay_status === EPayStatus.已签收 ||
      this.props.orderInfo.pay_status === EPayStatus.已完成;

    if (express && canSearchExpress) {
      const logisticNo = express.order_no;
      const logisticInfo = await MallService.getExpressDetail(logisticNo);
      if (logisticInfo) {
        this.setState({ logisticInfo });
        if (logisticInfo && logisticInfo.traces && logisticInfo.traces.length > 0) {
          this.setState({ showExpress: true });
          this.setState({ latestLogisticInfo: logisticInfo.traces[0] });
        }
      }
    }
  }

  editLogistics = (type: 0 | 1) => {
    const { invoiceLogistics, orderLogistics } = this.props;
    const lg = type === 0 ? orderLogistics : invoiceLogistics;
    this.setState({
      logisticsVisible: true,
      logisticsType: type,
      expressNumber: lg ? lg.expressNumber : '',
      logisticsCompany: lg ? lg.logisticsCompany : '',
    });
  };

  companyChange = (e: any) => {
    this.setState({
      logisticsCompany: e.target.value,
    });
  };

  expressNumberChange = (e: any) => {
    this.setState({
      expressNumber: e.target.value,
    });
  };

  moreLogisticInfo = () => {
    const { logisticInfo } = this.state;
    this.props.handleLogisticInfo(logisticInfo);
  }

  async handleUpdateLogistics() {
    this.setState({ logisticsVisible: false }, () => {
      this.props.changeLogistics({
        logisticsCompany: this.state.logisticsCompany || '',
        expressNumber: this.state.expressNumber || '',
        logisticsType: this.state.logisticsType,
      });
    });
  }

  /** 取药方式 */
  formatTakeMethod(type: string): string {
    let name = '';
    switch (type) {
      case 'SELF':
        name = '自提';
        break;
      case 'EXPRESS':
        name = '快递';
        break;
    }
    return name;
  }

  render() {
    const { invoiceLogistics, orderLogistics, isAgent, orderInfo, structureAddress } = this.props;
    const isReadOnly = isAgent || orderInfo.pay_status >= EPayStatus.已发货;

    const found = SUPPORT_EXPRESSES.find(e => e.value === orderLogistics.logisticsCompany);
    const company = found ? found.name : orderLogistics.logisticsCompany;
    const takeMethod = this.formatTakeMethod(orderInfo.medicine_take_method);
    return (
      <div>
        <div className="div-row">
          <div className="div-col-3 text-align-right">{'取药信息'}</div>
          <div className="div-col-15 order_info">
            <Descriptions title="" bordered={false}>
              <Descriptions.Item label="取药方式">{takeMethod}</Descriptions.Item>
            </Descriptions>
            <Descriptions title="" bordered={false}>
              <Descriptions.Item label={I18N.get('order_receiver')}>{orderInfo.receiver_name}</Descriptions.Item>
              <Descriptions.Item label={I18N.get('common_mobile')}>{orderInfo.receiver_mobile}</Descriptions.Item>
              {orderInfo.medicine_take_method === 'SELF' && (<Descriptions.Item label="取药码">
                {orderInfo.medicine_take_code || ''}
              </Descriptions.Item>)}
            </Descriptions>
            <Descriptions title="" bordered={false}>
              {orderInfo.medicine_take_method === 'SELF' && (<Descriptions.Item label="自提地址">
                {structureAddress},{orderInfo.self_mention_address}
              </Descriptions.Item>)}
              {orderInfo.medicine_take_method === 'EXPRESS' && (<Descriptions.Item label="收货地址">
                {structureAddress},{orderInfo.receiver_address}
              </Descriptions.Item>)}
            </Descriptions>

            {orderInfo.medicine_take_method === 'EXPRESS' && (<Descriptions title="" bordered={false}>
              {!!invoiceLogistics && (
                <React.Fragment>
                  <Descriptions.Item label="发票物流">{!isReadOnly && <a onClick={() => this.editLogistics(1)}>修改</a>}</Descriptions.Item>
                  <Descriptions.Item label="物流公司">{invoiceLogistics.logisticsCompany}</Descriptions.Item>
                  <Descriptions.Item label="快递单号">{invoiceLogistics.expressNumber}</Descriptions.Item>
                </React.Fragment>
              )}

              <Descriptions.Item label="物流公司">{company}</Descriptions.Item>
              <Descriptions.Item label="快递单号">{orderLogistics.expressNumber}</Descriptions.Item>
            </Descriptions>)}
          </div>
          <Modal
            title={`修改物流信息`}
            visible={this.state.logisticsVisible}
            onOk={() => this.handleUpdateLogistics()}
            onCancel={() => this.setState({ logisticsVisible: false })}
            okText="确认"
            cancelText="取消"
          >
            <p>
              物流公司
              <TextArea value={this.state.logisticsCompany} onChange={this.companyChange} rows={1} />
            </p>
            <p>
              快递单号
              <TextArea value={this.state.expressNumber} onChange={this.expressNumberChange} rows={1} />
            </p>
            <div />
          </Modal>
        </div>
        {this.state.showExpress && orderInfo.medicine_take_method === 'EXPRESS' &&
          <div className="div-row">
            <div className="div-col-3 text-align-right" />
            <div className="div-col-15 order_info logistic-info">
              <p>
                <img src={car} alt='' />
                <span> {UtilDateTime.datetimeFormat('yyyy-MM-dd hh:mm:ss', new Date(this.state?.latestLogisticInfo?.accepted_time))}
                  {this.state?.latestLogisticInfo?.accepted_station}</span>
              </p>
              <p className='more' onClick={this.moreLogisticInfo}> 物流详情 {`>`} </p>
            </div>
          </div>
        }
      </div>
    );
  }
}

export default LogisticsInfo;



// WEBPACK FOOTER //
// ./src/components/views/Order/components/LogisticsInfo.tsx